import React from 'react';
import { HostInfo } from '~/shared/types';

const HostInfoContext = React.createContext<HostInfo | null>(null);

export default HostInfoContext;
